import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuillEditorBase } from 'ngx-quill';
import * as QuillNamespace from 'quill';
const Quill: any = QuillNamespace;
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { ModalService } from 'src/app/services/modal/modal.service';
import { AutoreplaceService } from 'src/app/services/autoreplace/autoreplace.service';
import { Autoreplace } from 'src/app/utils/interfaces/new/autoreplace.interface';
import { HeaderFooterService } from 'src/app/services/header-footer/header-footer.service';
import { LoginService } from 'src/app/services/login/login.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { DisplayDocumentService } from 'src/app/services/display-document/display-document.service';
import { TexteModele, TypeEnum } from 'src/app/utils/interfaces/new/TexteModele';
import { TexteService } from 'src/app/services/texte/texte.service';
import { SearchInputFragment } from '../../search-input/search-input.fragment';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-courrier-perso',
  templateUrl: './add-courrier-perso.fragment.html',
  styleUrls: [
    './add-courrier-perso.fragment.scss',
    '../modal.fragment.scss'
  ],
  /**
   * Ce fragment est appelé dans une modal et ne récupère pas les modules
   * On les ajoute donc ici pour y avoir accès
   */
  providers: [
    DirectivesModule
  ]
})
export class AddCourrierPersoFragment implements OnInit {

  @ViewChild('quillDrop') public quillRef: QuillEditorBase;
  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;
  @ViewChild('searchInput') public searchInput: SearchInputFragment;

  errorMessage: string;

  courrierForm: FormGroup;

  tableName: string = "tag";

  private _initialAutoReplaceArray: Array<Autoreplace> = [];
  autoReplaceBodyTable: Paginated<Autoreplace> = {
    objects: [],
    page: 1,
    perpage: -1,
    total: 0
  }

  autoReplaceColumnTable = [
    { title: 'Nom de la variable', data: 'quickKey' }
  ];

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _texte: TexteService,
    private _modal: ModalService,
    private _view: ViewContainerRef,
    private _replace: AutoreplaceService,
    private _headFoot: HeaderFooterService,
    private _login: LoginService,
    private _patient: PatientService,
    private _displayDocumentSrv: DisplayDocumentService,
    private _strUtilsSrv: StringUtilsService,
  ) {

  }


  async ngOnInit(): Promise<void> {
    this.courrierForm = this._formBuilder.group({
      titre: ['', Validators.required],
    });
    this.autoReplaceBodyTable.objects = await this.getListByName(this.tableName);
    this._initialAutoReplaceArray = this.autoReplaceBodyTable.objects;
  }

  public closeAddEditModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  async saveCourrier() {
    // if (this.IS_OK_FOR_EDIT) {
    this.courrierForm.markAllAsTouched();
    if (this.courrierForm.valid) {
      const courrierPerso: TexteModele = {
        id: '',
        titre: this.courrierForm.controls['titre'].value,
        text: this.quillRef.quillEditor.root.innerHTML,
        type: TypeEnum.Courrier,
      }
      await this._texte.addTexteToUser(courrierPerso);
      this.closeAddEditModal();
    }
    // } else {
    //   this._modal.openAlert(this._view, "Consultation non modifiable", "La consultation sélectionnée n'est plus modifiable");
    // }
  }

  async dropped(event: any) {
    // if (this.IS_OK_FOR_EDIT) {
    const autoRep = this.autoReplaceBodyTable.objects[event.previousIndex];
    let texte = "";
    if (autoRep.isFunction) {
      texte = "@" + this.tableName + "." + autoRep.quickKey + "@";
    } else {
      texte = autoRep.note;
    }
    const range = this.quillRef.quillEditor.getSelection();
    if (range) {
      if (range.length == 0) {
        this.quillRef.quillEditor.clipboard.dangerouslyPasteHTML(range.index, texte);
      } else {
        this.quillRef.quillEditor.deleteText(range.index, range.length);
        this.quillRef.quillEditor.clipboard.dangerouslyPasteHTML(range.index, texte);
      }
    } else {
      this.quillRef.quillEditor.clipboard.dangerouslyPasteHTML(0, texte);
    }

  }

  async changeTable(tableInfo: string) {
    this.searchInput.searchInput = '';

    this.tableName = tableInfo;
    this.autoReplaceBodyTable.objects = await this.getListByName(this.tableName);
    this._initialAutoReplaceArray = this.autoReplaceBodyTable.objects;
  }

  public filterAutoreplaceList(needle: string): void {
    const _normalizeStr = (str: string): string => {
      return this._strUtilsSrv.removeAccents(str).toLowerCase();
    };

    if (needle && needle !== '') {
      this.autoReplaceBodyTable.objects = this._initialAutoReplaceArray.filter(a => _normalizeStr(a.quickKey).includes(_normalizeStr(needle)));
    } else {
      this.autoReplaceBodyTable.objects = this._initialAutoReplaceArray;
    }
  }

  async getListByName(name: string): Promise<Autoreplace[]> {
    return await this._replace.findByName(name);
  }

}
